
// private/IOJ3HsZEXv8qP/ptir6BAgERQzJ/invoices/f2d880a3-a29b-404b-9d45-73931242bc88/Balitrand.PDF
// private/IOJ3HsZEXv8qP/ptir6BAgERQzJ/fr/5f7c10d8-2663-4cf6-aa94-7cf8b505d6ac/20260220092409_dmFsaWRfMTc3MTU3OTQ0ODkzN18wLnBkZgAA.pdf

export enum CONTENTIO_MODULE_ENUM {
    JNEXT = "jnext"
}

export enum CONTENTIO_SUBMODULE_ENUM {
    UPLOADS = "uploads"
}

export const DEFAULT_CONTENTIO_MODULENAME = CONTENTIO_MODULE_ENUM.JNEXT;

export const DEFAULT_CONTENTIO_MIDDLEPATH = CONTENTIO_SUBMODULE_ENUM.UPLOADS;

export enum CONTENTIO_ACCESS_MODIFIER {
    PUBLIC = "PUBLIC",
    PRIVATE = "PRIVATE",
}

export interface ContentIoFile {
    type: "private" | "public";
    remotePath: string;
    imgSrc: string;
}

export interface UploadParameters {
    moduleName?: CONTENTIO_MODULE_ENUM;
    middlePath?: CONTENTIO_SUBMODULE_ENUM;
    subDir?: string;
    accessModifier?: CONTENTIO_ACCESS_MODIFIER;
    destination?: "default" | "zendesk";
}

export interface UploadResult {
    fileRef: string;
    reason?: string | null;
    uploaded: boolean;
}